import { VarianceCellRenderer } from '@/components/StoreMonitoring/StoreDetailsPage/TabView/Forecast/Forecasts'
import type { useFormatter } from '@/api/useFormatter'
import type { ColumnsType } from 'antd/lib/table'

const formattedRows = ['price', 'distance', 'estimated drop'] as const

export function formatValue(
  label: string,
  value: string | number,
  formatterHook: ReturnType<typeof useFormatter>
): string | number | null {
  const format = formattedRows.find((item) => label.toLowerCase().includes(item))
  switch (format) {
    case 'price':
      return formatterHook.formatCurrency(Number(value), true)
    case 'distance': {
      if (typeof value !== 'number') return value
      let descriptor = 'closer'
      if (value < 0) {
        descriptor = 'further'
      }
      return formatterHook.formatDistance(Math.abs(value), false) + ` ${descriptor}`
    }
    case 'estimated drop':
      return formatterHook.formatVolume(Number(value), true)
    default:
      return value
  }
}

export function getTableColumns(details: Gravitate.OrderFlag['details'][], varianceThreshold: number): ColumnsType {
  return details[0]?.map((col) => {
    const key = col.label.toLowerCase().replace(' ', '_')

    const column = {
      title: col.label === 'Loaded Mile Difference' ? 'Terminal Distance' : col.label,
      dataIndex: key,
      key,
      onHeaderCell: () => ({
        style: {
          textTransform: 'none' as const,
        },
      }),
    }

    if (col.label.toLowerCase() === 'variance') {
      return {
        ...column,
        render: (text: string | number | null, record: Record<string, string | number | null>) => {
          return <VarianceCellRenderer forecast={record.forecast} variance={text} threshold={varianceThreshold} />
        },
      }
    }

    return column
  })
}

export function getTableDataSource(
  details: Gravitate.OrderFlag['details'][],
  formatterHook: ReturnType<typeof useFormatter>
) {
  return details.map((row) => {
    const rowData: Record<string, string | number | null> = {}
    row.forEach((col) => {
      const key = col.label.toLowerCase().replace(' ', '_')
      rowData[key] = formatValue(col.label, col.value, formatterHook)
    })
    return rowData
  })
}
